import styled, { css } from 'styled-components'

export const TorrentCard = styled.div`
  ${({
    theme: {
      torrentCard: { cardPrimaryColor, cardBorderColor, cardShadow },
    },
  }) => css`
    border-radius: 20px;
    display: grid;
    grid-template-columns: 120px minmax(0, 1fr) 164px;
    grid-template-rows: 180px;
    grid-template-areas: 'poster description buttons';
    gap: 10px;
    padding: 12px;
    min-width: 0;
    box-sizing: border-box;
    background: ${cardPrimaryColor};
    border: 1px solid ${cardBorderColor};
    box-shadow: ${cardShadow};
    backdrop-filter: blur(18px);

    @media (max-width: 1260px), (max-height: 500px) {
      grid-template-areas:
        'poster description'
        'buttons buttons';

      grid-template-columns: 70px 1fr;
      grid-template-rows: 110px max-content;
    }

    @media (max-width: 770px) {
      grid-template-columns: 60px 1fr;
      grid-template-rows: 90px max-content;
    }
  `}
`

export const TorrentCardPoster = styled.div`
  grid-area: poster;
  border-radius: 14px;
  overflow: hidden;
  text-align: center;
  position: relative;

  ${({
    isPoster,
    theme: {
      torrentCard: { cardSecondaryColor, accentCardColor },
    },
  }) =>
    isPoster
      ? css`
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 14px;
          }
        `
      : css`
          display: grid;
          place-items: center;
          background: ${cardSecondaryColor};
          border: 1px solid ${accentCardColor};

          svg {
            transform: translateY(-3px);
          }
        `};

  @media (max-width: 1260px), (max-height: 500px) {
    svg {
      width: 50%;
    }
  }
`

export const TorrentCardButtons = styled.div`
  grid-area: buttons;
  display: grid;
  grid-template-rows: repeat(5, minmax(0, 1fr));
  gap: 6px;
  min-width: 0;
  min-height: 0;

  @media (max-width: 1260px), (max-height: 500px) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
    grid-template-rows: 34px;
  }

  @media (max-width: 340px) {
    gap: 5px;
  }
`
export const TorrentCardDescription = styled.div`
  ${({
    theme: {
      torrentCard: { cardSecondaryColor, accentCardColor },
    },
  }) => css`
    grid-area: description;
    background: ${cardSecondaryColor};
    border-radius: 14px;
    padding: 10px;
    display: grid;
    grid-template-rows: minmax(0, 1fr) auto;
    gap: 10px;

    @media (max-width: 770px) {
      gap: 3px;
    }

    .description-title-wrapper {
      display: flex;
      flex-direction: column;
      min-height: 0;
    }

    // .description-title-wrapper > .description-section-name {
    //   display: flex;
    //   flex-wrap: nowrap;
    //   justify-content: space-between;
    //   self-align: end;
    // }

    // .description-category-wrapper {
    //   display: inline-flex;
    //   color: #1a1a1a;
    // }

    .description-section-name {
      text-transform: uppercase;
      font-size: 10px;
      font-weight: 600;
      letter-spacing: 0.4px;
      color: ${accentCardColor};

      @media (max-width: 770px) {
        font-size: 0.5rem;
        line-height: 10px;
      }
    }

    .description-status-wrapper {
      display: inline-block;
      height: 8px;
      margin-inline-end: 4px;
      vertical-align: baseline;
    }

    .description-torrent-title {
      overflow: hidden;
      word-break: break-all;
    }

    .description-statistics-wrapper {
      display: grid;
      grid-template-columns: 80px 80px 1fr;
      row-gap: 3px;
      align-self: end;
      min-width: 0;

      @media (max-width: 1260px), (max-height: 500px) {
        grid-template-columns: 70px 70px 1fr;
      }

      @media (max-width: 770px) {
        grid-template-columns: 65px 65px 1fr;
      }

      @media (max-width: 700px) {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
      }
    }

    .description-statistics-element-wrapper {
      min-width: 0;
    }

    .description-statistics-element-value {
      margin-bottom: 2px;
      margin-left: 0;
      padding-right: 4px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-variant-numeric: tabular-nums;

      @media (max-width: 1260px), (max-height: 500px) {
        font-size: 0.7rem;
        margin-bottom: 0;
        margin-left: 0;
      }
    }

    .description-cache-wrapper {
      grid-column: 1 / -1;
      display: flex;
      align-items: baseline;
      gap: 6px;
      min-width: 0;

      .description-section-name {
        flex: 0 0 auto;
      }

      .description-statistics-element-value {
        flex: 1 1 auto;
        min-width: 0;
        margin-bottom: 0;
        padding-right: 0;
        font-weight: 500;
      }
    }

    .description-torrent-title,
    .description-statistics-element-value {
      @media (max-width: 770px) {
        font-size: 0.6rem;
      }

      @media (max-width: 410px) {
        font-size: 9px;
      }
    }
  `}
`

export const StyledButton = styled.button`
  ${({
    theme: {
      torrentCard: { buttonBGColor, accentCardColor },
    },
  }) => css`
    border-radius: 12px;
    border: none;
    cursor: pointer;
    transition: 0.2s;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    background: ${buttonBGColor};
    color: #fff;
    font-size: 0.76rem;
    letter-spacing: 0.009em;
    padding: 0 8px;
    font-weight: 650;
    width: 100%;
    min-width: 0;
    min-height: 0;
    box-sizing: border-box;
    overflow: hidden;

    svg {
      width: 18px;
      flex: 0 0 18px;
    }

    :hover {
      background: ${accentCardColor};
    }

    &[aria-pressed='true'] {
      background: ${accentCardColor};
      box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.38), inset 0 3px 8px rgba(0, 0, 0, 0.28);
      transform: translateY(1px);
    }

    :disabled {
      cursor: not-allowed;
      opacity: 0.58;
    }

    > :first-child {
      margin-right: 6px;
    }

    span {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    @media (max-width: 1260px), (max-height: 500px) {
      padding: 7px 10px;
      justify-content: center;
      font-size: 0.66rem;
      letter-spacing: 0;
      min-width: 0;

      svg {
        display: none;
      }

      span {
        min-width: 0;
        white-space: nowrap;
      }
    }

    @media (max-width: 770px) {
      font-size: 0.56rem;
      padding: 7px 5px;
    }

    @media (max-width: 420px) {
      font-size: 0.48rem;
      padding: 6px 3px;
    }
  `}
`

export const StatusIndicators = styled.div`
  ${({ color }) => css`
    height: 8px;
    width: 8px;
    background-color: ${color};
    border-radius: 50%;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  `}
`
